
import { useEffect } from 'react';
import './App.css';
import Main from './Component/Main';

function App() {
  
  
  return (
    <div className="App boxColor">
      <Main></Main>
     
            
    </div>
  );
}

export default App;
